var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('router-view',{attrs:{"session":_vm.session}}),_c('Navigation',{attrs:{"session":_vm.session}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }